import { createFileRoute, redirect } from '@tanstack/react-router';

// The inbox (CO-0554) is the lane Updates of Werk now (CO-1386, ADR-0038); old links keep working.
export const Route = createFileRoute('/_app/inbox')({
  beforeLoad: () => {
    throw redirect({ to: '/werk', search: { lane: 'updates' } });
  },
});
